// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__OAS8K","pagination__button":"Pagination_pagination__button__xedIl","pagination__rows-per-page":"Pagination_pagination__rows-per-page__m4L30"};